package com.evoapps.evoshift.auth

import com.evoapps.evoshift.domain.provider.GoogleCredential
import com.evoapps.evoshift.domain.provider.GoogleSignInClient
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider
import dev.gitlive.firebase.auth.externals.signInWithPopup
import dev.gitlive.firebase.auth.js
import kotlinx.coroutines.await

/**
 * Firebase's own Google popup. It already signs in; the repository signs in again with the
 * returned tokens, which is the same account, so all platforms share one path.
 */
class WebGoogleSignInClient : GoogleSignInClient {
    override suspend fun signIn(): GoogleCredential? {
        val result = try {
            signInWithPopup(Firebase.auth.js, GoogleAuthProvider()).await()
        } catch (e: Throwable) {
            // Closing the popup is not an error worth showing.
            val code = e.asDynamic().code as? String
            if (code in CANCELLED) return null
            // A JS Error is not a Kotlin Exception: hand the callers one they catch.
            throw IllegalStateException("Google sign-in failed: ${code ?: e.message}", e)
        }
        val credential = GoogleAuthProvider.credentialFromResult(result) ?: return null
        return GoogleCredential(idToken = credential.idToken, accessToken = credential.accessToken)
    }

    private companion object {
        val CANCELLED = setOf("auth/popup-closed-by-user", "auth/cancelled-popup-request", "auth/user-cancelled")
    }
}
